"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("./helpers");

var _excluded = ["treeData", "arData", "closedNodes"],
    _excluded2 = ["children"],
    _excluded3 = ["data"],
    _excluded4 = ["data"],
    _excluded5 = ["data"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DataManager = function DataManager(OriginalComponent) {
  var DataManagerComponent = /*#__PURE__*/function (_Component) {
    _inherits(DataManagerComponent, _Component);

    var _super = _createSuper(DataManagerComponent);

    function DataManagerComponent() {
      var _this;

      _classCallCheck(this, DataManagerComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        data: [],
        closedNodes: [],
        isToggledVisibility: false
      });

      _defineProperty(_assertThisInitialized(_this), "getTreeGridState", function (props, state) {
        var treeData = props.data,
            params = props.params;
        var stateClosedNodes = state.closedNodes;

        if (!treeData) {
          return {
            data: [],
            isToggledVisibility: false
          };
        }

        var idKey = (0, _helpers.getIdKey)(params);
        var closedLevel = params.treeGrid && params.treeGrid.closedLevel;
        var prevClosedNodes = stateClosedNodes && stateClosedNodes.length ? _toConsumableArray(stateClosedNodes) : [];

        var _this$convertDataTree = _this.convertDataTreeToArray({
          treeData: treeData,
          state: state,
          idKey: idKey,
          closedLevel: closedLevel,
          closedNodes: prevClosedNodes
        }),
            arData = _this$convertDataTree.arData,
            closedNodes = _this$convertDataTree.closedNodes;

        return {
          data: arData,
          isToggledVisibility: false,
          closedNodes: closedNodes
        };
      });

      _defineProperty(_assertThisInitialized(_this), "convertDataTreeToArray", function (props) {
        var treeData = props.treeData,
            _props$arData = props.arData,
            arData = _props$arData === void 0 ? [] : _props$arData,
            _props$closedNodes = props.closedNodes,
            closedNodes = _props$closedNodes === void 0 ? [] : _props$closedNodes,
            restProps = _objectWithoutProperties(props, _excluded);

        if (treeData.map) {
          // if treeData is array
          treeData.forEach(function (item, itemIndex, arr) {
            return _this.addItemArrayFromTreeData(_objectSpread({
              data: item,
              arData: arData,
              closedNodes: closedNodes,
              itemIndex: itemIndex,
              arLength: arr.length
            }, restProps));
          });
        } else if ((0, _helpers.isObject)(treeData)) {
          // if data is object ( first level of data by default for now )
          _this.addItemArrayFromTreeData(_objectSpread({
            data: treeData,
            arData: arData,
            closedNodes: closedNodes
          }, restProps));
        }

        return {
          arData: arData,
          closedNodes: closedNodes
        };
      });

      _defineProperty(_assertThisInitialized(_this), "addItemArrayFromTreeData", function (props) {
        var data = props.data,
            state = props.state,
            idKey = props.idKey,
            closedLevel = props.closedLevel,
            arData = props.arData,
            closedNodes = props.closedNodes,
            _props$level = props.level,
            level = _props$level === void 0 ? 0 : _props$level,
            _props$delimiter = props.delimiter,
            delimiter = _props$delimiter === void 0 ? {} : _props$delimiter,
            _props$itemIndex = props.itemIndex,
            itemIndex = _props$itemIndex === void 0 ? 0 : _props$itemIndex,
            _props$arLength = props.arLength,
            arLength = _props$arLength === void 0 ? 1 : _props$arLength;

        var children = data.children,
            restData = _objectWithoutProperties(data, _excluded2);

        var isExistInClosedNodes = closedNodes.some(function (id) {
          return id === data[idKey];
        });
        var isClosedByParams = closedLevel === level && !state.isToggledVisibility;
        var isClosed = isExistInClosedNodes || isClosedByParams;
        var hasChildren = Boolean(children && Array.isArray(children) && children.length);

        var item = _objectSpread(_objectSpread({}, restData), {}, {
          level: level,
          opened: !isClosed,
          tree: true,
          // mb dont need the props
          firstChild: itemIndex === 0,
          lastChild: itemIndex === arLength - 1,
          children: hasChildren
        });

        if (level > 0) {
          item.delimiter = delimiter;
        }

        arData.push(item);

        if (hasChildren && isClosed && !isExistInClosedNodes) {
          closedNodes.push(item[idKey]);
        }

        if (hasChildren && !isClosed) {
          var newDelimiter = _objectSpread(_objectSpread({}, delimiter), {}, _defineProperty({}, level, !(itemIndex === arLength - 1)));

          _this.convertDataTreeToArray({
            treeData: children,
            state: state,
            idKey: idKey,
            closedLevel: closedLevel,
            arData: arData,
            closedNodes: closedNodes,
            level: level + 1,
            delimiter: newDelimiter
          });
        }
      });

      _defineProperty(_assertThisInitialized(_this), "toggleRowVisibility", function (e, node) {
        e.stopPropagation();

        _this.setState({
          closedNodes: node.opened ? _this.addClosedNode(node) : _this.removeClosedNode(node),
          isToggledVisibility: true
        });
      });

      _defineProperty(_assertThisInitialized(_this), "removeClosedNode", function (node) {
        return _this.state.closedNodes.filter(function (item) {
          return item !== node[(0, _helpers.getIdKey)(_this.props.params)];
        });
      });

      _defineProperty(_assertThisInitialized(_this), "addClosedNode", function (node) {
        return [].concat(_toConsumableArray(_this.state.closedNodes), [node[(0, _helpers.getIdKey)(_this.props.params)]]);
      });

      return _this;
    }

    _createClass(DataManagerComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var params = this.props.params;

        if (params.treeGrid) {
          var _this$getTreeGridStat = this.getTreeGridState(this.props, this.state),
              gridStateData = _this$getTreeGridStat.data,
              restGridState = _objectWithoutProperties(_this$getTreeGridStat, _excluded3);

          this.setState(_objectSpread({
            data: gridStateData
          }, restGridState));
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$props = this.props,
            data = _this$props.data,
            params = _this$props.params;
        var isToggledVisibility = this.state.isToggledVisibility;

        if (params.treeGrid && (prevProps.data !== data || isToggledVisibility)) {
          var _this$getTreeGridStat2 = this.getTreeGridState(this.props, this.state),
              gridStateData = _this$getTreeGridStat2.data,
              restGridState = _objectWithoutProperties(_this$getTreeGridStat2, _excluded4);

          this.setState(_objectSpread({
            data: gridStateData
          }, restGridState));
        }
      }
    }, {
      key: "render",
      value: function render() {
        var stateData = this.state.data;

        var _this$props2 = this.props,
            propsData = _this$props2.data,
            restProps = _objectWithoutProperties(_this$props2, _excluded5);

        if (restProps.params.treeGrid) {
          return /*#__PURE__*/_react["default"].createElement(OriginalComponent, _extends({}, restProps, {
            data: stateData,
            toggleRowVisibility: this.toggleRowVisibility
          }));
        }

        return /*#__PURE__*/_react["default"].createElement(OriginalComponent, this.props);
      }
    }]);

    return DataManagerComponent;
  }(_react.Component);

  DataManagerComponent.propTypes = {
    data: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object])
  };
  DataManagerComponent.defaultProps = {
    data: []
  };
  return DataManagerComponent;
};

DataManager.propTypes = {};
DataManager.defaultProps = {};
var _default = DataManager;
exports["default"] = _default;